import { CLERK_PUBLISH_KEY } from '~/config';
import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import theme from '~/theme';
import UpdateChecker from '~/modules/components/global/update-checker';
import AuthModal from '~/modules/components/global/auth-modal';
import ClerkAuthModal from '~/modules/components/global/auth-modal-clerk';
import AuthService from '~/modules/services/auth-service';
import { ClerkLoaded, ClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import SessionProvider from '~/modules/providers/session-provider';
import { Toaster } from '~/components/ui/sonner';
import GuestAccessBootstrap from '~/modules/components/global/guest-access-bootstrap';
import Router from './modules/router';

export function PixwelApp() {
	const [queryClient] = useState(() => new QueryClient({
		defaultOptions: {
			queries: {
				// ✅ turns retries off when running inside cypress
				retry: window.Cypress?.isRunning ? false : 3
			}
		}
	}));
	const isClerk = window.location.search.includes('clerk') || AuthService.isJWT();

	return (
		<ClerkProvider
			publishableKey={`${CLERK_PUBLISH_KEY}`}
			appearance={{
				baseTheme: dark
			}}
		>
			<QueryClientProvider client={queryClient}>
				<SessionProvider>
					<ThemeProvider theme={theme}>
						<Toaster />
						{isClerk ? <ClerkAuthModal/> : <AuthModal/>}
						<UpdateChecker/>
						<ClerkLoaded>
							<GuestAccessBootstrap>
								<Router/>
							</GuestAccessBootstrap>
						</ClerkLoaded>
					</ThemeProvider>
				</SessionProvider>
			</QueryClientProvider>
		</ClerkProvider>
	);
}

export default PixwelApp;
